import CheckboxCell from "../components/PurchasesTreeTable/cells/CheckboxCell.vue";
import FavouriteCell from "../components/PurchasesTreeTable/cells/FavouriteCell.vue";
import SectorCell from "../components/PurchasesTreeTable/cells/SectorCell.vue";
import LotCell from "../components/PurchasesTreeTable/cells/LotCell.vue";
import ProposalNameCell from "../components/PurchasesTreeTable/cells/ProposalNameCell.vue";
import DaysLeftCell from "../components/PurchasesTreeTable/cells/DaysLeftCell.vue";
import DocumentsCell from "../components/PurchasesTreeTable/cells/DocumentsCell.vue";
import DefaultTooltip from "../components/PurchasesTreeTable/tooltips/DefaultTooltip.vue";
import DocumentsTooltip from "../components/PurchasesTreeTable/tooltips/DocumentsTooltip.vue";
import LotTooltip from "../components/PurchasesTreeTable/tooltips/LotTooltip.vue";
import ProposalSourceCell from "../components/PurchasesTreeTable/cells/ProposalSourceCell.vue";
import ProposalSourceTooltip from "../components/PurchasesTreeTable/tooltips/ProposalSourceTooltip.vue";
import ProposalNameTooltip from "../components/PurchasesTreeTable/tooltips/ProposalNameTooltip.vue";
import ProposalNumberCell from "../components/PurchasesTreeTable/cells/ProposalNumberCell.vue";
import ProposalNumberTooltip from "../components/PurchasesTreeTable/tooltips/ProposalNumberTooltip.vue";
import OrganizationTooltip from "../components/PurchasesTreeTable/tooltips/OrganizationTooltip.vue";
import UnpCell from "../components/PurchasesTreeTable/cells/UnpCell.vue";

const CELL_COMPONENTS = {
  sector: {
    component: SectorCell,
    tooltipComponent: DefaultTooltip,
    hasTooltip: true,
  },
  proposalName: {
    component: ProposalNameCell,
    tooltipComponent: ProposalNameTooltip,
    hasTooltip: true,
  },
  lot: {
    component: LotCell,
    tooltipComponent: LotTooltip,
    hasTooltip: true,
  },
  proposalNumber: {
    component: ProposalNumberCell,
    tooltipComponent: ProposalNumberTooltip,
    hasTooltip: true,
  },
  documents: {
    component: DocumentsCell,
    tooltipComponent: DocumentsTooltip,
    hasTooltip: true,
  },
  proposalSource: {
    component: ProposalSourceCell,
    tooltipComponent: ProposalSourceTooltip,
    hasTooltip: true,
  },
  hidden: {
    component: CheckboxCell,
    hasTooltip: false,
    width: 52 + 14 + 14,
  },
  favorites: {
    component: FavouriteCell,
    hasTooltip: false,
    width: 24,
  },
  expirationDays: {
    component: DaysLeftCell,
    hasTooltip: false,
  },
  organization: {
    hasTooltip: true,
    tooltipComponent: OrganizationTooltip,
  },
  unp: {
    component: UnpCell,
    hasTooltip: true,
  },
};

export default CELL_COMPONENTS;
